import { render } from "./Logo.vue?vue&type=template&id=6e8b700e&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=6e8b700e&lang=scss&scoped=true"

import exportComponent from "D:\\code\\newspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8b700e"]])

export default __exports__